import { transport } from 'config/transport';

export function callApiGetListStudent(classId, isActive = true) {
    return transport.get(`/mamnon/classes/${classId}/students`, { params: { isActive } });
}
